export * from "./StorageKeys";
export * from "./api";
export * from "./cart";
export * from "./track";
export * from "./menu";
export * from "./messages";

export const BAD_PAYLOAD_FOR_STORAGE = "JS Bridge: Bad Payload given to Storage.";
export const WINDOW_NOT_AVAILABLE = "Window not available";

export const DISTANCE_THRESHOLD = 500; // in meters
export const AUTH_REDIRECTION_URL = "{0}/auth/?prevPath={1}";

export enum PageName {
    MENU = "MENU",
    SEARCH = "SEARCH",
    TRACK = "TRACK",
    CART = "CART",
    BILL_SUMMARY = "BILL_SUMMARY",
    COLLECTIONS = "COLLECTIONS",
}

export enum PLATFORM {
    ANDROID = "Swiggy-Android",
    IOS = "Swiggy-iOS",
    WEB = "Swiggy-Mweb",
}

export const NEW_RELIC_APPLICATION_ID = process.env.NEXT_PUBLIC_NEW_RELIC_APP_ID || "";

export const COLLECTIONS_TEXTS = {
    HEADING: "No items found",
    DESCRIPTION: "Try adjusting your filters or browse other collections",
};

export const COLLECTIONS_EMPTY_STATE_IMG = {
    WIDTH: 220 * 2,
    HEIGHT: 215 * 2,
    id: "portal/static-assets/images/digital-menu/all-theme-assets/no_results_final.png",
};

export const TABLE_ERROR_STATE = {
    title: "Your table has been closed",
    description: "Please scan again to continue",
};

export const BILL_SUMMARY_SUCCESS_STATUS_CODES = [0, 8]; // 0 is success, 8 is bill pending

// TODO: Should be moved to env config
export const RAZORPAY_SCRIPT_URL = "https://checkout.razorpay.com/v1/checkout.js";

export const CROUTON_WEBVIEW_IOS_VERSION = 534;

export const GIRF_PAYMENT = "GIRF_PAYMENT";
export const EVENTS = "EVENTS";
export const PREEBOOK_PREPAID = "Prebook-Prepaid";

// polling constants
export const BILL_POLL_BASE_DELAY_SECONDS = 2; // first delay and linear increment
export const BILL_POLL_MAX_DELAY_SECONDS = 15; // clamp per-attempt delay to this
export const BILL_POLL_MAX_TOTAL_MS = 180000; // stop after 3 minutes

export const ROUTES = {
    MENU: "/qr/menu",
    SEARCH: "/qr/menu/search",
    TRACK: "/qr/track",
    CART: "/qr/cart",
    CART_ORDERS: "/qr/cart-orders",
    COLLECTIONS: "/qr/collections",
    BILL_SUMMARY: "/qr/bill-summary",
};

export const ANDROID_THIRD_PARTY_AVAILABLE_MIN_VERSION =
    process.env.NEXT_PUBLIC_ANDROID_THIRD_PARTY_AVAILABLE_MIN_VERSION || 1595;
export const IOS_THIRD_PARTY_AVAILABLE_MIN_VERSION =
    process.env.NEXT_PUBLIC_IOS_THIRD_PARTY_AVAILABLE_MIN_VERSION || 706;
export const CART_NATIVE_BRIDGE_FLOW_TYPE = "DIGITAL_MENU";
export const DEFAULT_BACK_ROUTE = ROUTES.MENU;
